import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { fullDateFullYearFormat } from "@common/helpers/date";
import { parseISO, format } from "date-fns";
import { ClientDetailsRow } from "../clientViewConfig";
import { EMPTY_CELL_VALUE } from "./lib";

export const SubscriptionStartDateCell = ({
    row,
    getValue,
}: CellContext<ViewTableFeatures, ClientDetailsRow, string | null>) => {
    // Only display for workspace rows, not entities
    if (row.original.type === "entity") {
        return EMPTY_CELL_VALUE;
    }

    const value = getValue();

    if (!value) {
        return EMPTY_CELL_VALUE;
    }

    const formattedDate = format(parseISO(value), fullDateFullYearFormat);

    return <ViewTableCell>{formattedDate}</ViewTableCell>;
};
